import { ALLOWED_REFERRER_ORIGINS, APPLICATION_URL, GANDALF_TOKEN_ISS } from "./constants";
import { getNodeEnvironment, NodeEnvironment } from "./nodeEnvironment";

export const getApplicationURL = (): APPLICATION_URL => {
  const nodeEnvironment: NodeEnvironment = getNodeEnvironment();
  switch (nodeEnvironment) {
    case NodeEnvironment.BETA: {
      return APPLICATION_URL.BETA;
    }
    case NodeEnvironment.GAMMA: {
      return APPLICATION_URL.GAMMA;
    }
    case NodeEnvironment.PROD: {
      return APPLICATION_URL.PROD;
    }
    default: {
      return APPLICATION_URL.DEVELOPMENT;
    }
  }
};

export const formatActor = (userId?: string, vibeId?: string): string => {
  return JSON.stringify({
    name: userId ?? "none",
    openid: `${GANDALF_TOKEN_ISS}|${vibeId ?? "none"}`,
    objectType: "Agent",
  });
};

export const setSessionQueryParams = (): void => {
  const queryParams = window.location.search;
  if (queryParams.length > 0) {
    sessionStorage.setItem("queryParams", queryParams);
  }
};

export const getSessionQueryParams = (): string => {
  return sessionStorage.getItem("queryParams") ?? "";
};

/**
 * Validates if a referrer URL is allowed based on the current environment's allowlist
 * @param referrer The referrer URL to validate
 * @returns Boolean indicating if the referrer is valid
 */
export const isValidReferrer = (referrer: string | null): boolean => {
  if (!referrer) {
    return false;
  }

  try {
    const referrerUrl = new URL(referrer);
    const nodeEnvironment = getNodeEnvironment().toUpperCase();
    const allowedOrigins = ALLOWED_REFERRER_ORIGINS[nodeEnvironment as keyof typeof ALLOWED_REFERRER_ORIGINS];

    return allowedOrigins.includes(referrerUrl.origin);
  } catch {
    return false;
  }
};
